<template>
  <div class="list-content">
    <div class="code">
      <img src="@/assets/images/qrcode.png" alt="微信二维码" />
      <p>关注微信</p>
      <p>获取最新招聘信息</p>
    </div>
    <div class="list">
      <Table
        :columns="columns"
        :data="tableData"
        @on-row-dblclick="clickItem"
      ></Table>
      <div class="page">
        <Page
          :total="total"
          :show-total="true"
          @on-change="changePageNo"
          :page-size="pageSize"
        />
      </div>
    </div>
    <Modal
      v-model="showDetailModal"
      width="600"
      :mask-closable="false"
      :footer-hide="true"
      :scrollable="true"
      heigth="800"
    >
      <div slot="header" class="modal-header">职位详情</div>
      <detail ref="deatail" :positionId="selectPositionId" />
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import detail from "./PositionDetail";
import axios from "axios";
import { group } from "static/common.js";
export default {
  components: { detail },
  data() {
    return {
      showDetailModal: false,
      columns: [
        {
          title: "职位名称",
          key: "positionName",
          align: "center",
        },
        {
          title: "工作地点",
          key: "workPlace",
          align: "center",
        },
        {
          title: "所属公司",
          key: "company",
          align: "center",
        },
        {
          title: "薪资",
          key: "salary",
          align: "center",
        },
        {
          title: "招聘人数",
          key: "count",
          align: "center",
        },
      ],
      allData: [],
      total: 0,
      pageNo: 1,
      pageSize: 10,
      //   将总招聘数分组
      groupData: [],
      tableData: [],
      selectPositionId: -1,
    };
  },
  methods: {
    reqPositionData() {
      axios.get("./data.json").then((res) => {
        this.allData = res.data.positionData;
        this.groupData = group(this.allData, this.pageSize);
        this.total = this.allData.length;
        this.tableData = this.groupData[this.pageNo - 1];
      });
    },
    changePageNo(e) {
      this.pageNo = e;
      this.tableData = this.groupData[this.pageNo - 1];
    },
    clickItem(e) {
      this.selectPositionId = e.positionId;
      this.showDetailModal = true;
      let list = this.tableData;
      list.forEach((ele) => {
        if (this.selectPositionId == ele.positionId) {
          this.$refs.deatail.positionItemData = ele;
        }
      });
    },
  },
  mounted() {
    this.reqPositionData();
  },
};
</script>

<style scoped lang="less">
.list-content {
  display: flex;
}
.code {
  width: 200px;
  background-color: #fbfbfb;
  padding: 0 20px;
  img {
    width: 100%;
  }
  p {
    text-align: center;
    font-size: 16px;
    height: 30px;
    line-height: 30px;
    color: #666;
  }
}
.list {
  flex: 1;
}
.modal-header {
  text-align: center;
}
.page {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
</style>